export default function AboutSection() {
  const services = [
    {
      title: "긴급 배관 수리 서비스",
      desc: "야간, 주말 및 공휴일 상관없이 긴급상황 대비 전문 수리기사가 항시 대기 중이며, 전 지역 1시간 이내 방문하고 있습니다.",
    },
    {
      title: "다양한 전문 서비스",
      desc: "숙련된 전문 기술자를 통해 최신 기술과 장비로 배관의 다양한 문제를 가장 정확한 서비스로 보장합니다.",
    },
    {
      title: "투명한 가격 정책",
      desc: "서비스 제공 전에 명확한 가격을 안내하고 1:1 맞춤형 서비스를 제공합니다.",
    },
    {
      title: "철저한 품질 보증 A/S",
      desc: "정확하고 깔끔한 현장 정리와 A/S 성적을 통해 부로 재작업과 높은 만족도의 서비스를 제공합니다.",
    },
  ];

  const regions = [
    { name: "경기북부", count: 365, top: "18%", left: "52%" },
    { name: "서울", count: 528, top: "38%", left: "48%" },
    { name: "인천", count: 388, top: "42%", left: "18%" },
    { name: "경기남부", count: 498, top: "62%", left: "52%" },
  ];

  return (
    <section id="about" className="py-14 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">

        {/* Section Header */}
        <div className="text-center mb-10 lg:mb-16">
          <span className="inline-block text-blue-500 font-bold text-xs lg:text-sm tracking-widest uppercase mb-2 lg:mb-3">About Us</span>
          <h2 className="text-2xl lg:text-4xl font-black text-zinc-900 mb-3 lg:mb-4">
            왜 착한누수를 선택해야 할까요?
          </h2>
          <p className="text-zinc-500 text-sm lg:text-lg max-w-2xl mx-auto">
            누수 전문업체로서 오직 <strong className="text-zinc-700">기술력과 신뢰</strong>로 고객과 함께해왔습니다.
          </p>
        </div>

        {/* 차별화된 서비스 제공 */}
        <div className="mb-12 lg:mb-20">
          <h3 className="text-xl lg:text-2xl font-black text-zinc-900 mb-2">차별화된 서비스 제공</h3>
          <p className="text-zinc-500 text-xs lg:text-sm mb-6 lg:mb-8 leading-relaxed max-w-2xl">
            전문 기술력과 최고급 장비를 통해 신속하고 정확하게 배관 문제를 원인부터<br />
            완벽하게 해결하는 1:1 고객 맞춤형 서비스를 제공합니다.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 lg:gap-5">
            {services.map((s) => (
              <div
                key={s.title}
                className="border border-zinc-200 rounded-xl p-4 lg:p-6 hover:border-blue-300 hover:bg-blue-50/40 transition-all duration-200"
              >
                <div className="flex items-start gap-3">
                  <div className="w-5 h-5 lg:w-6 lg:h-6 flex items-center justify-center text-blue-500 mt-0.5 shrink-0">
                    <i className="ri-checkbox-circle-fill text-lg lg:text-xl" />
                  </div>
                  <div>
                    <h4 className="text-zinc-900 font-bold text-sm lg:text-base mb-1 lg:mb-2">{s.title}</h4>
                    <p className="text-zinc-500 text-xs lg:text-sm leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 수도권 전역 서비스 */}
        <div>
          <h3 className="text-xl lg:text-2xl font-black text-zinc-900 mb-2">수도권 전역 서비스</h3>
          <p className="text-zinc-500 text-xs lg:text-sm mb-7 lg:mb-10 leading-relaxed max-w-2xl">
            착한누수는 서울 경기 전역에 걸쳐 빠르고 신뢰할 수 있는 서비스를 제공합니다.<br />
            각 권역별 지점에 위치한 풍부한 현장 경험과 노하우를 가진 전문가들이<br />
            고객의 누수 문제를 신속하고 정확하게 진단하여 해결합니다.
          </p>

          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Map area */}
            <div>
              <div className="mb-3 lg:mb-4">
                <span className="text-2xl lg:text-3xl font-black text-zinc-900">총 1,779건 시공</span>
                <p className="text-blue-500 text-xs lg:text-sm font-semibold mt-1">2026년 02월 기준</p>
              </div>
              <div className="relative w-full" style={{ height: "320px" }}>
                <img
                  src="https://public.readdy.ai/ai/img_res/efaf96e7c074bf1a25e7cc9d2f4ceb4e.jpg"
                  alt="수도권 지도"
                  className="w-full h-full object-cover object-top rounded-2xl"
                />
                {/* Region badges */}
                {regions.map((r) => (
                  <div
                    key={r.name}
                    className="absolute bg-white border-2 border-blue-500 rounded-xl px-3 py-2 text-center shadow-md"
                    style={{ top: r.top, left: r.left, transform: "translate(-50%, -50%)" }}
                  >
                    <div className="text-xs font-bold text-zinc-600 whitespace-nowrap">{r.name}</div>
                    <div className="text-lg font-black text-blue-500 leading-tight">{r.count}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right text */}
            <div className="flex flex-col justify-center">
              <h4 className="text-xl lg:text-2xl font-black text-zinc-900 mb-4 lg:mb-5 leading-snug">
                신속한 연결,<br />
                <span className="text-blue-500">신뢰할 수 있는</span> 맞춤 해결 서비스
              </h4>
              <p className="text-zinc-500 text-xs lg:text-sm leading-relaxed mb-4 lg:mb-5">
                착한누수는 고객과의 신속한 연결을 통해 문제를 빠르게 해결합니다. 고객이 전화를 걸면 즉시 전문가와 연결되어 문제를 상담할 수 있으며, 필요한 경우 빠른 시간 내에 현장방문을 약속드립니다.
              </p>
              <p className="text-zinc-500 text-xs lg:text-sm leading-relaxed mb-6 lg:mb-8">
                착한누수는 고객의 만족을 최우선으로 생각하며, 신속하고 정확한 서비스를 제공합니다.
              </p>

              {/* Region stats row */}
              <div className="grid grid-cols-2 gap-3 lg:gap-4">
                {regions.map((r) => (
                  <div key={r.name} className="bg-zinc-50 rounded-xl p-3 lg:p-4 border border-zinc-100">
                    <div className="text-blue-500 font-black text-xl lg:text-2xl">{r.count}</div>
                    <div className="text-zinc-500 text-xs mt-1">{r.name} 시공 건수</div>
                  </div>
                ))}
              </div>

              <a
                href="tel:010-2684-4892"
                className="mt-6 lg:mt-8 inline-flex items-center gap-2 bg-blue-500 hover:bg-blue-400 text-white font-bold px-5 lg:px-7 py-3 lg:py-3.5 rounded-full transition-all cursor-pointer whitespace-nowrap w-fit text-sm lg:text-base"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill" />
                </span>
                지금 바로 상담하기
              </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}